module.exports = __webpack_public_path__ + "static/media/2_en.c31bff07.png";